/**
 * Reorder Array to start on a specific index
 */
export const startFromIndex = <T = unknown>(data: T[], index: number) => data.slice(index).concat(data.slice(0, index))
